export default {
    currentHash: '',
}
